import { useDevice } from '../../../hooks/useResponsive';
import FooterMobile from './FooterMobile';
import FooterWeb from './FooterWeb';

export default function Footer() {
  const { isMobile } = useDevice();
  return <>{isMobile ? <FooterMobile /> : <FooterWeb />}</>;
}
Footer.propTypes = {};
